app.controller('visitEditController', ['$rootScope', '$scope', '$state', '$stateParams', 'objectHelper', 'baseModel', 'applicationModel', 'visitModel',
    function ($rootScope, $scope, $state, $stateParams, objectHelper, baseModel, applicationModel, visitModel) {

        function setData() {
            $scope.forms = {
                visitForm: null
            };

            $scope.visit = null;

            $scope.now = new Date();
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on(Event.VISIT.GET_BY_ID.SUCCESS, function(event, visit) {
                $scope.visit = visit;
            });
        }

        function setActions() {


            $scope.save = function () {
                $scope.forms.visitForm.$setSubmitted();
                if($scope.forms.visitForm.$valid) {
                    visitModel.update($scope.visit);
                    var successDisabler = $scope.$on(Event.VISIT.UPDATE.SUCCESS, function (event, visit) {
                        $scope.goBack(Constant.STATE.APP.HOME);
                        successDisabler();
                        errorDisabler();
                    });
                    var errorDisabler = $scope.$on(Event.VISIT.UPDATE.ERROR, function (event, visit) {
                        successDisabler();
                        errorDisabler();
                    });
                }
            };
        }

        function configureInterface() {
        }

        function initialize() {
            visitModel.getById($stateParams.visitId);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
